export const getStyle = (isFinalAnswer: boolean) => ({
  row: isFinalAnswer ? "border-transparent" : "border-purple-2",
  cell: isFinalAnswer ? "" : "border-t-2 border-t-purple-2",
});
